import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {Button, Col, Row} from "react-bootstrap";
import moment from "moment";
import {connect} from "react-redux";
import Modal from "../Modal";
import FormInput from "../forms/FormInput";
import FormLangInput from "../forms/FormLangInput";
import FormLangRichEditor from "../forms/FormLangRichEditor";
import FormAutocomplete from "../forms/FormAutocomplete";
import DateTimePicker from "../forms/DateTimePicker";
import FormSwitchery from "../forms/FormSwitchery";
import Loader from "../layout/Loader";
import {addServiceTypeR} from "../../actions/ServiceTypesActions";
import DatePicker from "../forms/DatePicker";

class ProvisionServiceDocumentsDownload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchDate: undefined,
    };
  }

  componentDidUpdate = (prevProps) => {
  }

  updateSearchDate = (fieldName, searchDate) => {
    if (fieldName === 'searchMonth') {
      this.setState({ searchDate:  searchDate.format('YYYY-MM') });
    }
  };



  render() {
    const { intl, show, close, appIntl, user} = this.props;
    const { } = this.state;
    const messages = intl.messages;
    const timezone = user && user.profile ? user.profile.timezone : 'UTC';
    console.log("searchdate", this.state.searchDate);
    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.provision_service_documents_download}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <DatePicker
                  name="searchMonth"
                  value={this.state.searchDate}
                  locale={appIntl.locale}
                  displayTz={timezone}
                  onChange={this.updateSearchDate} // Todo look for a monthpicker
                  label={messages.provision_service_documents_choose_month}
                />
              </div>

              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm" >
                {this.state.pending ?  <Loader/>:<></>}
                <Button onClick={()=>this.props.getDocuments(this.state.searchDate)}  disabled="" bsStyle="primary"  className="pull-right" title="create_service_type">
                  <span className="hidden-xs">{messages.provision_service_documents_download_start}</span>
                </Button>
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProvisionServiceDocumentsDownload)
  )
);

